import React from 'react';
import history from '../../../history';
import fire from '../../../auth/firebase';
import '../../styles/styles.css';

export class Login extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            alertShow: false,
            setShow: '',
            isFailure: false,
            errMessage: '',
            emailError: '',
            passwordError: '',
            email: '',
            password: ''
        };

        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.clearInputs = this.clearInputs.bind(this);
        this.clearError = this.clearErrors.bind(this);
    }

    clearInputs() {
        this.setState({ email: '', password: '', confirmPassword: '' })
    }

    clearErrors() {
        this.setState({ emailError: '', passwordError: '', confirmPasswordError: '', successMessage: '' })
    }

    onChange(e) {
        this.clearErrors();
        console.log(e.target.name);
        this.setState({ [e.target.name]: e.target.value });
    }

    onSubmit(e) {
        console.log(this.state.email);
        e.preventDefault();
        const user = {
            email: this.state.email,
            password: this.state.password
        };

        fire
            .auth()
            .signInWithEmailAndPassword(user.email, user.password)
            .then(res => {
                if (!fire.auth().currentUser.emailVerified) {
                    this.setState({ emailError: 'Account needs verificiation, please confirm the sent email', isFailure: true, alertShow: true });

                } else {
                    localStorage.setItem('user', res);
                    history.push(`/surgical`);
                }
            })
            .catch(error => {
                console.log(error);
                // eslint-disable-next-line default-case
                switch (error.code) {
                    case "auth/invalid-email":
                    case "auth/user-disabled":
                    case "auth/user-not-found":
                        this.setState({ emailError: error.message, isFailure: true, alertShow: true });
                        break;
                    case "auth/wrong-password":
                        this.setState({ passwordError: error.message, isFailure: true, alertShow: true });
                        break;
                }
            });

    }

    render() {

        return (
            <section className="login">
                <div className="loginContainer">
                    <label>Email</label>
                    <input
                        type="text"
                        name="email"
                        autoFocus
                        required
                        value={this.email}
                        onChange={e => this.onChange(e)}
                    />
                    <p className="errorMsg">{this.state.emailError}</p>
                    <label>Password</label>
                    <input
                        type="password"
                        name="password"
                        required
                        value={this.password}
                        onChange={e => this.onChange(e)}
                    />
                    <p className="errorMsg">{this.state.passwordError}</p>
                    <div className="btnContainer">
                        <>
                            <button onClick={this.onSubmit}>Sign in</button>
                            <p>
                                Don't have an account?
                            <span onClick={() => window.location.href = '/register'}>Sign up</span>
                            </p>
                            <p>
                                Forgot your password?
                            <span onClick={() => window.location.href = '/forgot_password'}>Reset password</span>
                            </p>
                        </>
                    </div>
                </div>
            </section>
        )
    }
}